import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import { getLocalStorage } from "../layout/cookies/CookieFunctions";

const useStyles = makeStyles((theme) => ({
  marginNormal: {
    marginTop: theme?.spacing ? theme.spacing(2) : null,
    marginBottom: theme?.spacing ? theme.spacing(1) : null,
  },
}));

const DateTimePickerComponent = (props) => {
  const {
    name,
    label,
    value,
    helperText,
    error,
    setFieldValue,
    variant,
    required,
    disableFuture,
    zIndex,

    setFieldTouched,
    touched,

    margin,
    disabled,
  } = props;
  const classes = useStyles();
  var parentParams = {};
  if (required) {
    parentParams.required = required;
  }

  const locale = getLocalStorage("locale") || "en-us";

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <DateTimePicker
        className={classes.marginNormal}
        fullWidth
        inputVariant={variant || "outlined"}
        label={label}
        name={name}
        autoOk
        disabled={disabled}
        disableFuture={disableFuture || false}
        value={moment(value)}
        onChange={(newMoment) => {
          if (newMoment && newMoment !== null) {
            setFieldValue(name, newMoment.format("YYYY-MM-DDTHH:mm"), true);
          } else {
            setFieldValue(name, null, true);
          }
          if (setFieldTouched && touched) setFieldTouched(name);
        }}
        {...parentParams}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin={margin}
            required={required}
            error={error}
            helperText={helperText}
            disabled={disabled}
          />
        )}
        PopperProps={{
          style: {
            zIndex: `${(zIndex || 99990) + 3} !important`,
          },
        }}
        sx={{ width: "100%" }}
      />
    </LocalizationProvider>
  );
};

export default DateTimePickerComponent;
